import React from 'react';

const IconCheck = (props) => {
  const width = props.size || 10;
  const height = (width * 7) / 10;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M9 1L3.5 6.5L1 4"
        stroke={props.color || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconCheck;
